import { Stack, StackProps } from "@chakra-ui/react"
import React from "react"

interface Props extends StackProps {
    row?: boolean
}

export default function SharedStack({
    row = false,
    children,
    ...props
}: Props) {
    return (
        <Stack
            w="full"
            justify="flex-start"
            align="flex-start"
            direction={row ? "row" : "column"}
            {...props}
        >
            {children}
        </Stack>
    )
}
